import { ca } from '@cian/analytics';

export const trackSaveOfferNote = (id: number | undefined, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'save',
    category: 'Click',
    label: 'comment',
    products: [
      {
        id,
        offerType: 'offer',
        position: position + 1,
      },
    ],
  });
};

export const trackCloseOfferNote = (id: number | undefined, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'close',
    category: 'Click',
    label: 'comment',
    products: [
      {
        id,
        offerType: 'offer',
        position: position + 1,
      },
    ],
  });
};
